const createPartnerForm = document.querySelector('#registerPartner');
const createPartnerBtn = createPartnerForm?.querySelector('.partner-join-signin-link.create');
const createNewPartnerForm = document.querySelector('#create_customer');
const returnTo = createNewPartnerForm?.querySelector('input[name="return_to"]');

const showPaymentInCart =
  KROWN.settings.payment_method_selection.should_show_in_cart;

// #region create buttons

createPartnerBtn?.addEventListener('click', async () => {
  if (createPartnerForm.querySelector('.alert')) {
    createPartnerForm.querySelectorAll('.alert').forEach((elm) => elm.remove());
  }

  const inputs = createPartnerForm.querySelectorAll('input');
  const checkboxes = Array.from(inputs).filter(input => input.type === "checkbox" && input.className != "switch__input");
  let checked = true;

  checkboxes.forEach(checkbox => {
    if (!checkbox.checked) {
      checked = false;
    }
  });

  if (!checked) {
    showValidationError("checkbox", "existing");
    return;
  }

  const variantId = Array.from(inputs).find((input) => input.getAttribute('name') === 'variant-id').value;
  const sellingPlanId = Array.from(inputs).find((input) => input.getAttribute('name') === 'selling-plan-id').value;
  const discountValue = Array.from(inputs).find((input) => input.getAttribute("name") === "discount-value").value;

  const updates = {};
  updates['' + variantId] = 0;

   const paymentMethod =
     window.cartAvailablePaymentMethods.subscription.includes("Online")
       ? "Online"
       : window.cartAvailablePaymentMethods.subscription[0];

  const isManualPayment =
    KROWN.settings.manualPaymentTypes.includes(paymentMethod);

  const item = {
    id: variantId,
    quantity: 1,
    selling_plan: isManualPayment ? null : sellingPlanId,
  };

    item.properties = {
      _sellingplan: isManualPayment ? sellingPlanId : "",
      _discountvalue: discountValue,
    };

  const formData = {
    attributes: {
      _paymentMethod: paymentMethod,
      _newFlow: false,
      _availablePayments: window.cartAvailablePaymentMethods.subscription,
    },
    items: [item],
  };
  
  const congratulationsMessage = document.querySelector('#congratulations-message').value;
  if (congratulationsMessage === "true") {
    formData.attributes._partnerFeeProduct = variantId;
  }

  // show loader
  createPartnerBtn.classList.add('display-none');
  createPartnerBtn.closest('.partner-join-form-btn').classList.add('no-click');
  createPartnerBtn.closest('.partner-join-form-btn').querySelector('.partner-loader').classList.remove('display-none');

  await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).catch((error) => {
    console.error(error);
  });

  await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).catch((error) => {
    console.error(error);
  });

  // refresh cart after adding
  await refreshCartForPartner();

  const hasNoSubscriptionPaymentMethod = !window.cartAvailablePaymentMethods.subscription.length;
  const hasMultipleSubscriptions = window.cartAvailablePaymentMethods.subscription.length > 1;

  if (hasNoSubscriptionPaymentMethod || (hasMultipleSubscriptions && showPaymentInCart)) {
    // Redirect to cart page
    window.location.href = KROWN.settings.routes.cart_url;
  } else {
    // Proceed to checkout
    const checkoutBtn = document.querySelector('.checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.click();
    }
  }
  createPartnerBtn.closest('.partner-join-form-btn').querySelector('.partner-loader').classList.add('display-none');
  createPartnerBtn.classList.remove('display-none');
  createPartnerBtn.closest('.partner-join-form-btn').classList.remove('no-click');
});

createNewPartnerForm?.addEventListener('submit', function (event) {
  if (createNewPartnerForm.querySelector('.alert')) {
    createNewPartnerForm.querySelectorAll('.alert').forEach((elm) => elm.remove());
  }

  const inputs = createNewPartnerForm.querySelectorAll('input');

  const inputFields = Array.from(inputs).filter(input => input.classList.contains('form-input-field'));
  const checkboxes = Array.from(inputs).filter(input => input.type === "checkbox" && !input.classList.contains('switch__input') && !input.classList.contains('js-partner-referral-toggle') && input.id !== "leadPoolAssign");
  const passwordLength = document.querySelector('#password').value.trim().length;

  let filled = true;
  let checked = true;

  inputFields.forEach(inputField => {
    if (inputField.id !== "customer-registration-tags" && inputField.value.trim() === "") {
      filled = false;
    }
  });

  if (!filled) {
    event.preventDefault();
    showValidationError("input", "new");
    return;
  }

  checkboxes.forEach(checkbox => {
    if (!checkbox.checked) {
      checked = false;
    }
  });

  if (!checked) {
    event.preventDefault();
    showValidationError("checkbox", "new");
    return;
  }

  if (passwordLength < 5 || passwordLength > 40) {
    event.preventDefault();
    showValidationError("password", "new");
    return;
  }

  window.sessionStorage.setItem('customerRegistrationSession', 'true');
  const registrationTags = [];
  const associatedPartnerId = window.getAssociatedPartnerId();
  if (associatedPartnerId) {
    registrationTags.push(`comsysPartnerId:${associatedPartnerId}`);
  }
  const shouldAssignToLeadPool = !!document.getElementById('leadPoolAssign')?.checked;
  if (shouldAssignToLeadPool) {
    registrationTags.push('wasLeadPoolSelected');
  }
  document.querySelector("#customer-registration-tags").value = registrationTags.join(',');
});

// #endregion

// #region helper methods


// function to dynamically add and append alerts
const showValidationError = (errorType, formType) => {
  const errorParent = document.createElement('span');
  const errorSymbol = document.createElement('span');
  const errorTextContainer = document.createElement('span');

  errorParent.classList.add('alert', 'alert--error', 'alert--icon');
  errorSymbol.classList.add('alert__icon');

  errorSymbol.innerHTML = KROWN.settings.symbols.alert_icon;

  switch (errorType) {
    case "input":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_input_error;
      break;

    case "checkbox":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_checkbox_error;
      break;

    case "password":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_password_error;
      break;
  }

  errorParent.append(errorSymbol);
  errorParent.append(errorTextContainer);

  let form = undefined;
  let firstNode = undefined;

  switch (formType) {
    case "existing":
      form = document.querySelector('.partner-join-form');
      firstNode = document.querySelector('.partner-join-form-checkbox');
      break;

    case "new":
      form = createNewPartnerForm;
      firstNode = document.querySelector('.partner-join-form__row');
      break;
  }

  form.insertBefore(errorParent, firstNode);
};

// refresh cart
async function refreshCartForPartner() {
  await fetch('?section_id=helper-cart')
    .then((response) => response.text())
    .then((text) => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

      const cartItems = document.getElementById('AjaxCartForm');
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
        elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
      });

      document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
        elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
      });

      document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

      if (document.querySelector('cart-recommendations')) {
        document.querySelector('cart-recommendations').innerHTML = '';
        document.querySelector('cart-recommendations').generateRecommendations();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

// #endregion
